<template>
	<div>
		<el-form :inline="true" :model="subordinateForm" class="demo-form-inline" style="margin-bottom: 10px">
				<el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
				<el-button size="medium"  type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
		</el-form>
<!-- //打印 -->
			<prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
		<!--    表格部分-->
		<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
			v-loading="loading" border id="tableDataId" height="500" size="mini">
			<el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="user_name" label="代理商姓名">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="mobile_phone" label="代理商电话">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="p_user_name" label="上级代理商">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="p_mobile_phone" label="上级手机号">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="pre_org_name" label="组织名称">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="org_name" label="运营中心">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="register_time" label="注册时间">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="register_length" label="注册时长（天）">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="total_num" label="总台数">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="bind_num" label="绑定台数">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="activate_num" label="已激活台数">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="not_activate_num" label="未激活台数">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="activate_rate" label="激活率">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="register_time" label="机损率">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="fushuashu" label="复刷台数">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="fushualv" label="复刷率">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="total_money" label="总交易金额">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="average" label="台均">
			</el-table-column>
		</el-table>
		<!-- 分页部分 -->
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
	</div>
</template>

<script>
	import {export_json_to_excel} from "@/excel/Export2Excel";
	import prints from '@/components/print.vue'
	export default {
		name: "subordinateList",
		props: {
			userId: Number
		},
		components:{
			prints
		},
		data() {
			return {
				loading: true, //列表loadding
				page_size: 20, //条数
				total: 0, //总数
				tableData: [], //表格数据
				subordinateForm: {
					user_id: this.userId,
					page_size: 20,
					page: 1,
				},
			}
		},
		computed: {

		},
		created() {
			this.getData(this.subordinateForm)
			this.tableTh = ['ID', '代理商姓名', '代理商电话', '上级代理商', '上级手机号', '组织名称', '运营中心', '注册时间', '注册时长（天）', '总台数', '绑定台数',
				'已激活台数', '未激活台数', '激活率', '机损率', '复刷台数', '复刷率', '总交易金额', '台均'
			];
			this.tableTd = ['id', 'user_name', 'mobile_phone', 'p_user_name', 'p_mobile_phone', 'pre_org_name',
				'org_name', 'register_time', 'register_length', 'total_num', 'bind_num', 'activate_num',
				'not_activate_num', 'activate_rate', 'register_time', 'fushuashu', 'fushualv', 'total_money',
				'average'
			];
			this.$nextTick(()=>{
				this.$refs.prints.prints();
			})
		},
		methods: {
			//打印
			printEvent(){
				this.$nextTick(()=>{
					this.$refs.prints.prints();
					this.$refs.prints.print();
				})
			},
			// 主页面部分
			//分页
			handleCurrentChange(page) { //当前选中页
				this.subordinateForm.page = page;
				this.getData(this.subordinateForm);
			},
			handleSizeChange(limit) { //条数
				this.subordinateForm.page_size = limit;
				this.subordinateForm.page = 1;
				this.getData(this.subordinateForm);
			},
			//获取数据
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("/api/data_center/riskList?page=" + params.page, params, res => {
					if (res.status == 200) {
						let tableData = res.data;
						this.total = tableData.total; //总数
						this.tableData = tableData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			// 导出
			exportData() {
				let th = ['ID', '代理商姓名', '代理商电话', '上级代理商', '上级手机号', '组织名称', '运营中心', '注册时间', '注册时长（天）', '总台数', '绑定台数',
					'已激活台数', '未激活台数', '激活率', '机损率', '复刷台数', '复刷率', '总交易金额', '台均'
				];
				let excelData = ['id', 'user_name', 'mobile_phone', 'p_user_name', 'p_mobile_phone', 'pre_org_name',
					'org_name', 'register_time', 'register_length', 'total_num', 'bind_num', 'activate_num',
					'not_activate_num', 'activate_rate', 'register_time', 'fushuashu', 'fushualv', 'total_money',
					'average'
				];
				let data = this.formatJson(excelData, this.tableData);
				let defaultTitle = '导出文件';
				export_json_to_excel(th, data, defaultTitle)
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
		}
	};
</script>

<style scoped>


</style>
